import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=2a207d69&scoped=true&"
import script from "./dictionary.vue?vue&type=script&lang=ts&"
export * from "./dictionary.vue?vue&type=script&lang=ts&"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=2a207d69&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a207d69",
  null
  
)

export default component.exports